<div ref="EntityRiskAssessment" class="border-card border-0 p-3 container-fluid px-3 px-md-4 py-3 py-md-4 ">
  <NavigationBackButton />
  <br />
  <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-3 g-md-4 ">
    <!-- Total Assessment Card -->
    <div class="col">
      <div class="card card-bg shadow rounded-lg border-0 h-100">
        <div class="card-body p-3">
          <div class="d-flex flex-column flex-sm-row justify-content-between h-100">
            <div class="mb-3 mb-sm-0">
              <p class="text-white mb-1 fs-6">Total Assessment</p>
              <p class="mb-0 text-primary-green fs-4">{{ total_assessment_count }}</p>
            </div>
            <div class="text-center text-sm-end">
              <div class="p-1 p-md-2">
                <i class="fa-solid fa-file-invoice text-primary fa-lg mb-2 mb-md-3"></i>
              </div>
              <a href="#" class="d-block text-primary-green text-decoration-none fs-6 fs-md-5">
                View
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pre-Assessment Card -->
    <div class="col">
      <div class="card card-bg shadow rounded-lg border-0 h-100">
        <div class="card-body p-3">
          <div class="d-flex flex-column flex-sm-row justify-content-between h-100">
            <div class="mb-3 mb-sm-0">
              <p class="text-white mb-1 fs-6">Pre-Assessment</p>
              <p class="mb-0 text-primary-green fs-4">{{ total_pre_assessment_count }}</p>
            </div>
            <div class="text-center text-sm-end">
              <div class="p-1 p-md-2">
                <i class="fa-solid fa-file-circle-exclamation fa-lg text-primary-green mb-2 mb-md-3"></i>
              </div>
              <a href="#" class="d-block text-primary-green text-decoration-none fs-6 fs-md-5">
                View
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Post-Assessment Card -->
    <div class="col">
      <div class="card card-bg shadow rounded-lg border-0 h-100">
        <div class="card-body p-3">
          <div class="d-flex flex-column flex-sm-row justify-content-between h-100">
            <div class="mb-3 mb-sm-0">
              <p class="text-white mb-1 fs-6">Post-Assessment</p>
              <p class="mb-0 text-primary-green fs-4">{{ total_post_assessment_count }}</p>
            </div>
            <div class="text-center text-sm-end">
              <div class="p-1 p-md-2">
                <i class="fa-solid fa-file-circle-check fa-lg text-primary-green mb-2 mb-md-3"></i>
              </div>
              <a href="#" class="d-block text-primary-green text-decoration-none fs-6 fs-md-5">
                View
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Table Card - Responsive by default -->
  <div class="card border-0 bg-white rounded-lg shadow mt-3 mt-md-4">
    <div class="card-header rounded-lg border-0 bg-white p-3 p-md-4">
      <p class="fs-md-6 mb-0">Risk Assessments</p> 
    </div>
    <div class="card-body p-3 p-md-4">
      <div class="table-responsive">
        <!-- Show GlobalTable when data exists -->
        <GlobalTable
          v-if="table_safe_form_list.length"
          :headers="form_table_headers"
          :data="table_safe_form_list"
          table_id="entity_form_management_table">
          <template #actions="{ row }">
            <button
              class="btn btn-primary-dark btn-sm rounded-small shadow text-dark ms-1 text-xxs"
              @click="redirect_to_answer_assessments">
              View
            </button>
          </template>
        </GlobalTable>
        
        <!-- Show empty state when no data -->
        <div v-else class="empty-table-message text-center py-5">
          <p class="text-muted mb-0 text-xs">No data available in table</p>
        </div>
      </div>
    </div>
  </div>
  <AICampusFooter/>
</div>